import React, {useState, useEffect} from 'react';
import {Button, CircularProgress} from "@material-ui/core";
import {getResourceData} from "../../Resource Center/Helpers";
import ResourceTile from "../../Resource Center/SubComponents/ResourceTile";
import useUserInfo from "../../../hooks/useUserInfo";
import PermissionTypes from "../../../constants/PermissionTypes";
import {makeStyles} from "@material-ui/core/styles";
import {useHistory} from "react-router-dom";

const ResourceCenterHighLevel = () => {
  const history = useHistory();

  const {permissions} = useUserInfo();
  const {cardContainer} = useStyles();

  // this component should only be rendered in cases where the user cannot view the case status table
  if (permissions.includes(PermissionTypes.VIEW_CASE_STATUS))
    return null;

  const [state, setState] = useState({
    loading: true,
    data: [],
    message: ''
  });

  useEffect(() => {
    const getData = async () => {
      const data = await getResourceData();

      if ((!data || !data.content)  || data.content.length < 1){
        await setState({...state, loading: false, message: 'No records to display.'});
        return;
      }

      let featuredItems = [...data.content];

      featuredItems = featuredItems.length > 5 ?
        featuredItems.slice(0, 5) : featuredItems.slice(0, featuredItems.length);

      await setState({...state, loading: false, message: '', data: featuredItems});
    }

    getData();
  }, [])

  if (state.loading) {
    return <div className="d-flex justify-content-center p-5"><CircularProgress /></div>;
  }

  const rcCards = state.data && state.data.map((v, i) => {
    return <ResourceTile {...v} key={i} />
  });

  return (
    <React.Fragment>
      <h4 className={'font-weight-bold'}>Resource Center</h4>
      <div className={cardContainer}>
        {state.message ? state.message : rcCards}
      </div>
      <div className={'d-flex justify-content-center p-5'}>
        <Button color="primary" className='link-btn-padding' variant="text" onClick={() => history.push('/ResourceCenter')}>VIEW ALL</Button>
      </div>
    </React.Fragment>
  );
};

const useStyles = makeStyles(theme => ({
  cardContainer: {
    display: 'inline-flex',
    marginTop: '4px',
    '& .MuiCard-root:first-child': {
      marginLeft: '0'
    }
  }
}));

export default ResourceCenterHighLevel;


// WEBPACK FOOTER //
// ./src/components/Home/SubComponents/ResourceCenterHighLevel.js